import PropTypes from 'prop-types';
var propTypes = {
  appearance: PropTypes.oneOf(['dropShadow', 'outlined']),
  component: PropTypes.elementType,
  content: PropTypes.node,
  customStyle: PropTypes.any,
  hoverable: PropTypes.bool,
  onClick: PropTypes.func
};
export default propTypes;